<template>
  <!-- 车辆管理 -->
  <div class="public_Spacing carManagement">
    <div class="pulbic_oparetionBlock">
      <div class="public_criteriaRange">
        <div class="public_oparetionBlock_Menu">
          <label class="public_lbSty">车牌号：</label>
          <div class="el-select public_optionSty">
            <div class="el-input el-input--suffix">
              <input
                maxlength="7"
                class="el-input__inner pulic_carNumber"
                type="text"
                placeholder="请输入"
                v-model="carNum"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="public_operatArea">
        <div class="public_operatBtn" style="margin-left: 0;">
          <button
            @click="queryClick"
            class="public_saleWater_chaxun pulic_cursor"
            v-shiroHiden="solelist"
            id="查询"
          >
            <i class="iconfont icon-chaxun"></i>查询
          </button>
          <button
            @click="newlyAdd"
            class="public_saleWater_xinzeng pulic_cursor"
            v-shiroHiden="solelist"
            id="新增"
          >
            <i class="iconfont icon-tianjia1"></i>新增
          </button>
          <!-- <button @click="exports" class="public_saleWater_daochu pulic_cursor"     id="导出"><i class="iconfont icon-daochu"></i>导出</button> -->
        </div>
      </div>
    </div>
    <div class="bcarManagement-table pulbic_table_container">
      <el-table
        :data="tableData"
        style="width: 100%;"
        max-height="90%"
        stripe
        :default-sort="{ prop: 'waterNum', order: 'descending' }"
        :header-cell-style="{
          color: 'rgba(51,51,51,1)',
          'font-weight': 'bold',
        }"
        class="public_tableColumn"
      >
        <!-- 	<el-table-column v-for='(item,index) in tableHeadList' :prop="item.prop" :label="item.label"
					:key="index">
				</el-table-column> -->

        <el-table-column type="expand">
          <template slot-scope="props">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item class="item-lxxx" label="联系信息">
                <span
                  class="itemMsg"
                  v-for="(item, index) in props.row.phoneName"
                >
                  <span>{{ item.ORMTB416CA00 }}:</span>
                  <span v-for="(item1, index) in item.ORMTB416CA01">
                    {{ item1.phone }}
                  </span>
                </span>
              </el-form-item>
              <!-- <el-form-item label="所属店铺">
								<span>{{ props.row.shop }}</span>
							</el-form-item> -->
            </el-form>
          </template>
        </el-table-column>

        <el-table-column label="车牌号" prop="carNums"> </el-table-column>
        <el-table-column label="联系人" prop="fname"> </el-table-column>
        <el-table-column label="联系电话" prop="fphone"> </el-table-column>
        <el-table-column label="皮重" prop="tareIpt"> </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              @click="modify(scope.row)"
              class="public_icon_xiugai public_icon_width  public_icon_margin"
              v-shiroHiden="solelist"
              id="修改"
              type="primary"
              size="small"
              >修改</el-button
            >
            <el-button
              v-shiroHiden="solelist"
              id="删除"
              @click="deleteClick(scope.row)"
              class="public_icon_jinyong public_icon_width"
              type="primary"
              size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pulbic_pagesize">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="limitMo"
          layout="total,sizes, prev, pager, next, jumper"
          :total="pagingPageMo"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 新增 -->
    <div class="public-dialog">
      <el-dialog
        title="新增车辆信息"
        @close="XAdd"
        :visible.sync="billOperationAdd"
        width="560px"
        :closeOnClickModal="false"
        append-to-body
        custom-class="sales-car-management-dialog"
      >
        <div class="systemCodePC-add-code">
          <div class="systemCodePC-add-code-table">
            <div class="systemCodePC-add-code-table-li">
              <div class="systemCodePC-add-code-table-li-name">车牌号</div>
              <div class="systemCodePC-add-code-table-li-ipt">
                <input
                  type="text"
                  class="car-number-add"
                  @input="numinput"
                  :maxlength="maxl"
                  v-model="carNumberAdd"
                />
              </div>
              <div class="systemCodePC-add-code-table-li-text">*必填*</div>
            </div>
            <div class="systemCodePC-add-code-table-li">
              <div class="systemCodePC-add-code-table-li-name">车主姓名</div>
              <div class="systemCodePC-add-code-table-li-ipt">
                <input type="text" v-model="carNameAdd" />
              </div>
              <div class="systemCodePC-add-code-table-li-text"></div>
            </div>
            <div class="systemCodePC-add-code-table-li">
              <div class="systemCodePC-add-code-table-li-name">车主电话</div>
              <div class="systemCodePC-add-code-table-li-ipt">
                <input
                  maxlength="11"
                  type="text"
                  v-model="carPhoneAdd"
                  v-on:input="carPhoneAdd = carPhoneAdd.replace(/[^\d]/g, '')"
                />
              </div>
              <div class="systemCodePC-add-code-table-li-text"></div>
            </div>
            <div class="systemCodePC-add-code-table-li">
              <div class="systemCodePC-add-code-table-li-name">皮重</div>
              <div class="systemCodePC-add-code-table-li-ipt">
                <input type="text" v-model="tareIptAdd" @keyup="tareIptAddUP" />
              </div>
              <div class="systemCodePC-add-code-table-li-text"></div>
            </div>
          </div>
          <div class="systemCodePC-add-code-btn">
            <el-button type="warning" @click="cancelAdd">取消</el-button>
            <el-button type="primary" @click="preservationAdd">保存</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
    <!-- 修改 -->
    <div class="public-dialog">
      <el-dialog
        title="修改车辆信息"
        @close="XAdd"
        :visible.sync="billOperationDetails"
        width="560px"
        :closeOnClickModal="false"
        append-to-body
        custom-class="sales-car-management-dialog"
      >
        <div class="systemCodePC-add-code">
          <div class="systemCodePC-add-code-table">
            <div class="systemCodePC-add-code-table-li">
              <div class="systemCodePC-add-code-table-li-name">车牌号</div>
              <div class="systemCodePC-add-code-table-li-ipt">
                <input
                  type="text"
                  class="car-number-add"
                  maxlength="7"
                  v-model="carNumberModify"
                  @input="numinputModify"
                  :maxlength="maxl"
                />
              </div>
              <div class="systemCodePC-add-code-table-li-text">*必填*</div>
            </div>
            <div class="systemCodePC-add-code-table-li">
              <div class="systemCodePC-add-code-table-li-name">车主姓名</div>
              <div class="systemCodePC-add-code-table-li-ipt">
                <el-select
                  v-model="carNameModify"
                  @change="selChangName"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in customerManagementList"
                    :key="item.ORMTB416ID"
                    :label="item.ORMTB416CA00"
                    :value="item.ORMTB416ID"
                  >
                  </el-option>
                </el-select>
                <!-- <input type="text" v-model="carNameModify" /> -->
              </div>
              <div class="systemCodePC-add-code-table-li-text"></div>
            </div>
            <div class="systemCodePC-add-code-table-li">
              <div class="systemCodePC-add-code-table-li-name">车主电话</div>
              <div class="systemCodePC-add-code-table-li-ipt">
                <el-select v-model="carPhoneModify" placeholder="请选择">
                  <el-option
                    v-for="item in customerManagementPhoneList"
                    :key="item.phone"
                    :label="item.phone"
                    :value="item.phone"
                  >
                  </el-option>
                </el-select>

                <!-- <input maxlength="11" type="text" v-model="carPhoneModify" v-on:input = "carPhoneModify=carPhoneModify.replace(/[^\d]/g,'')"/> -->
              </div>
              <div class="systemCodePC-add-code-table-li-text"></div>
            </div>
            <div class="systemCodePC-add-code-table-li">
              <div class="systemCodePC-add-code-table-li-name">
                修改后车主姓名
              </div>
              <div class="systemCodePC-add-code-table-li-ipt">
                <input type="text" v-model="edCarNameModify" />
              </div>
              <div class="systemCodePC-add-code-table-li-text"></div>
            </div>
            <div class="systemCodePC-add-code-table-li">
              <div class="systemCodePC-add-code-table-li-name">
                修改后车主电话
              </div>
              <div class="systemCodePC-add-code-table-li-ipt">
                <input
                  maxlength="11"
                  type="text"
                  v-model="edCarPhoneModify"
                  v-on:input="
                    edCarPhoneModify = edCarPhoneModify.replace(/[^\d]/g, '')
                  "
                />
              </div>
              <div class="systemCodePC-add-code-table-li-text"></div>
            </div>
            <div class="systemCodePC-add-code-table-li">
              <div class="systemCodePC-add-code-table-li-name">皮重</div>
              <div class="systemCodePC-add-code-table-li-ipt">
                <input
                  type="text"
                  v-model="tareIptModify"
                  @keyup="tareIptModifyUP"
                />
              </div>
              <div class="systemCodePC-add-code-table-li-text"></div>
            </div>
          </div>
          <div class="systemCodePC-add-code-btn">
            <el-button type="warning" @click="cancelModify">取消</el-button>
            <el-button type="primary" @click="preservationModify"
              >保存</el-button
            >
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userobj: this.$store.state.uobj, //登陆缓存--用户信息
      carNum: '',
      billOperationAdd: false,
      billOperationDetails: false,
      tableData: [],
      customerManagementList: [],
      customerManagementPhoneList: [],
      // tableHeadList: [{
      // 		prop: 'carNums',
      // 		label: '车牌号',
      // 	},
      // 	{
      // 		prop: 'phoneName',
      // 		label: '联系人',
      // 	},

      // 	{
      // 		prop: 'phone',
      // 		label: '联系电话',
      // 	}, {
      // 		prop: 'tareIpt',
      // 		label: '皮重',
      // 	},
      // ],
      // 新增
      carNumberAdd: '',
      carNameAdd: '',
      carPhoneAdd: '',
      tareIptAdd: '',
      judgeAdd: 0, //判断校验车辆，车辆类型是新增还是修改--新增
      maxl: '',
      // 修改
      SETTB402ID: '', //车辆id
      carNumberModify: '',
      carNameModify: '',
      carPhoneModify: '',
      tareIptModify: '',
      edCarNameModify: '',
      edCarPhoneModify: '',
      carID: '', //一二级客户车辆id
      judgeModify: 1, //判断校验车辆，车辆类型是新增还是修改--修改
      judgeCarNumMo: '', //判断修改时当前输入的车牌号是否和未修改之前的一样--修改
      pageMo: 1, //默认列表页码
      limitMo: 10, //每页的条数
      pagingPageMo: 0, //分页--数据列表共有的条数
      currentPage: 1, //设置当前页默认为1
      // 历史缓存
      currentUrl: this.$route.path,
      historyInfo: '',

      solelist: [],
    }
  },
  created() {
    var list = ''
    list = this.$store.state.solelist
    var path = this.$route.path
    this.solelist = this.$baseAPI.querSoleList(list, path) //获取权限列表
    this.userobj = this.$store.state.uobj
    // 赋值，缓存销毁
    console.log('currentUrl', this.currentUrl)
    this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl))
    sessionStorage.removeItem(this.currentUrl)
    if (this.historyInfo != null && this.historyInfo != '') {
      this.init()
    }
  },
  watch: {
    // 车牌号--查询
    carNum: function(val) {
      this.carNum = val.toUpperCase()
    },
    // 车牌号--新增
    carNumberAdd: function(val) {
      this.carNumberAdd = val.toUpperCase()
    },
    // 车牌号--修改
    carNumberModify: function(val) {
      this.carNumberModify = val.toUpperCase()
    },
  },
  mounted() {
    this.pageList()
  },
  // 存储数据
  beforeDestroy() {
    var obj = {
      carNum: this.carNum, //车牌号
      currentPage: this.currentPage, //当前页数
      pageMo: this.pageMo, //页码
      limitMo: this.limitMo, //每页条数
    }
    sessionStorage.setItem(this.currentUrl, JSON.stringify(obj))
  },
  methods: {
    //初始化数据
    init() {
      this.carNum = this.historyInfo.carNum
      this.currentPage = this.historyInfo.currentPage
      this.pageMo = this.historyInfo.pageMo
      this.limitMo = this.historyInfo.limitMo
    },
    selChangName() {
      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        ORMTB416ID: this.carNameModify, //联系人id
      }
      var url = '/set/settb402/queryPhone'
      this.axios
        .post(url, postData)
        .then(res => {
          if (res.data.code == 200) {
            // console.log(res.data.data)
            this.customerManagementPhoneList = res.data.data
            loading.close()
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },
    // 导出
    exports() {
      var SETTB402CA00 = this.carNum //车牌号
      var url =
        this.axios.defaults.baseURL +
        '/set/settb402/toExcel?SETTB402CA00=' +
        SETTB402CA00
      window.location.href = url
    },
    // 删除
    deleteClick(row) {
      var postData = {
        sign: this.userobj.pertb005.pertb005cb00,
        carID: row['carID'],
        SETTB402ID: row['carNumID'],
      }
      var url = '/set/settb402/delete'
      this.$confirm('此操作将删除该条数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.axios.post(url, postData).then(res => {
          // console.log(res)
          if (res.data.code == 200) {
            this.pageList()
            this.$message({
              type: 'success',
              message: '删除成功!',
            })
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
      })
    },
    numinput() {
      this.carNumberAdd = this.checkNum(this.carNumberAdd)
    },
    checkNum(item) {
      var regNum = /^[0-9]+$/
      var regALP = /^[0-9A-Z]+$/
      var regJane = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领]+$/
      var item = item.trim()
      item = item.toUpperCase()
      var regCar = /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][0-9]{1})$/
      var numarr = item.split('')
      var j, str, isnum
      for (var i = 0; i < numarr.length; i++) {
        if (i == 0) {
          if (!regJane.test(numarr[i])) return (item = item.slice(0, 0))
        } else if (i >= 1) {
          if (i == 1) {
            if (!regALP.test(numarr[i]))
              return (item = item.slice(0, item.length - 1))
            str = item.slice(0, 2)
            if (regCar.test(str)) {
              this.maxl = 8
              isnum = true
            } else {
              this.maxl = 7
              isnum = false
              item = item.slice(0, 7)
            }
          } else {
            if (isnum == true) {
              if (i == 2) {
                if (!regNum.test(numarr[i]))
                  return (item = item.replace(numarr[i], ''))
              }
            }
            if (!regALP.test(numarr[i]))
              return (item = item.slice(0, item.length - 1))
          }
        }
      }
      return item
    },
    // 新增保存
    preservationAdd() {
      var regC = /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领])|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][0-9]{2}([0-9]|[A-Z]){5}))$/
      var regP = /^1[3-9][0-9]{9}$/
      if (!regC.test(this.carNumberAdd)) {
        this.$message({
          message: '车牌号格式不正确，请检查!',
          type: 'error',
        })
      } else if (this.carPhoneAdd != '' && !regP.test(this.carPhoneAdd)) {
        this.$message({
          message: '手机号格式不正确，请检查!',
          type: 'error',
        })
      } else {
        // this.checkCarNumber(this.carNumberAdd, this.judgeAdd);
        this.postAdd()
      }
    },
    // 新增调用接口
    postAdd() {
      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      if (this.userobj.pertb005.pertb005cb00 == 'CUS-1') {
        var ORMTB400ID = this.userobj.ormtb400.ORMTB400ID
      } else if (this.userobj.pertb005.pertb005cb00 == 'CUS-2') {
        var ORMTB400ID = this.userobj.ormtb410.ORMTB410ID
      }
      var postData = {
        SETTB402CA00: this.carNumberAdd, //车牌号
        SETTB402CA01: this.carNameAdd, //车主姓名
        SETTB402CA02: this.carPhoneAdd, //车主电话
        sign: this.userobj.pertb005.pertb005cb00,
        personID: ORMTB400ID, //一二级客户id
        SETTB402CA03: this.tareIptAdd, //皮重
      }
      var url = '/set/settb402/insert'
      this.axios
        .post(url, postData)
        .then(res => {
          // console.log(res)
          if (res.data.code == 200) {
            if (res.data.message == '车牌号已存在,不能重复添加!') {
              this.$message({
                message: res.data.message,
                type: 'error',
              })
            } else {
              this.billOperationAdd = false
              this.$message({
                message: '新增成功',
                type: 'success',
              })
              this.pageList()
            }
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
          setTimeout(() => {
            loading.close()
          }, 300)
        })
        .catch(() => {
          loading.close()
        })
    },
    tareIptAddUP() {
      //限制验证码长度
      var value = this.tareIptAdd
      this.tareIptAdd = this.clearNoNum(value)
    },
    tareIptModifyUP() {
      var value = this.tareIptModify
      this.tareIptModify = this.clearNoNum(value)
    },
    // 校验车牌号重复
    checkCarNumber(val, index) {
      if (index == 0) {
        var postData = {
          SALTB416CA00: val, //车牌号
        }
      } else if (index == 1) {
        var postData = {
          SALTB416CA00: val, //车牌号
        }
      }
      var url = '/sal/saltb416/checkSaltb416ca00'
      this.axios.post(url, postData).then(res => {
        // console.log(res)
        if (res.data.result == 2) {
          if (index == 0) {
            this.postAdd()
          } else if (index == 1) {
            this.modifyPost()
          }
        } else {
          if (val == this.judgeCarNumMo) {
            if (index == 0) {
              this.postAdd()
            } else if (index == 1) {
              this.modifyPost()
            }
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        }
      })
    },
    // 新增取消--X
    XAdd() {
      this.materielIndex = 0
    },
    // 新增取消
    cancelAdd() {
      this.billOperationAdd = false
      // this.materielIndex = 0;
    },
    // 新增
    newlyAdd() {
      this.billOperationAdd = true
      this.judgeAdd = 0
      this.carNumberAdd = '' //车牌号
      this.carNameAdd = '' //姓名
      this.carPhoneAdd = '' //电话
      this.tareIptAdd = ''
    },
    numinputModify() {
      this.carNumberModify = this.checkNum(this.carNumberModify)
    },
    // 修改保存
    preservationModify() {
      var regC = /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领])|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][0-9]{2}([0-9]|[A-Z]){5}))$/
      var regP = /^1[3-9][0-9]{9}$/
      if (!regC.test(this.carNumberModify)) {
        this.$message({
          message: '车牌号格式不正确，请检查!',
          type: 'error',
        })
        return
      }
      if (this.edCarNameModify) {
        if (!this.carNameModify) {
          this.$message({
            message: '请选择要修改的车主姓名',
            type: 'error',
          })
          return
        }
      }

      if (this.edCarPhoneModify) {
        if (!this.carPhoneModify) {
          this.$message({
            message: '前选择要修改的电话',
            type: 'error',
          })
          return
        }

        if (!regP.test(this.edCarPhoneModify)) {
          this.$message({
            message: '手机号格式不正确，请检查!',
            type: 'error',
          })
          return
        }
      }
      // this.checkCarNumber(this.carNumberModify, this.judgeModify);
      this.modifyPost()
    },
    modifyPost() {
      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      if (this.userobj.pertb005.pertb005cb00 == 'CUS-1') {
        var ORMTB400ID = this.userobj.ormtb400.ORMTB400ID
      } else if (this.userobj.pertb005.pertb005cb00 == 'CUS-2') {
        var ORMTB400ID = this.userobj.ormtb410.ORMTB410ID
      }
      var postData = {
        SETTB402ID: this.SETTB402ID, //车辆id
        revise: this.judgeCarNumMo, //车牌号--默认
        SETTB402CA00: this.carNumberModify, //车牌号
        SETTB402CA01: this.carNameModify, //车主姓名
        SETTB402CA02: this.carPhoneModify, //车主电话
        newSETTB402CA01: this.edCarNameModify, //修改车主姓名
        newSETTB402CA02: this.edCarPhoneModify, //修改车主电话
        sign: this.userobj.pertb005.pertb005cb00,
        personID: ORMTB400ID,
        carId: this.carID, //一二级客户车辆id
        SETTB402CA03: this.tareIptModify, //皮重
      }
      var url = '/set/settb402/update'
      this.axios
        .post(url, postData)
        .then(res => {
          // console.log(res)
          setTimeout(() => {
            loading.close()
          }, 300)
          if (res.data.code == 200) {
            // if(this.carNumberModify== this.judgeCarNumMo){

            // 	this.billOperationDetails = false;
            // 	this.$message({
            // 		message: '修改成功',
            // 		type: 'success'
            // 	});
            // 	this.pageList();
            // }else{
            // 	if(res.data.message=='车牌号已存在,不能重复添加!'){
            // 		this.$message({
            // 			message: res.data.message,
            // 			type: 'error'
            // 		});
            // 	}
            // }
            if (res.data.message == '车牌号已存在,不能重复添加!') {
              this.$message({
                message: res.data.message,
                type: 'error',
              })
            } else {
              this.billOperationDetails = false
              this.$message({
                message: '修改成功',
                type: 'success',
              })
              this.pageList()
            }
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },
    // 修改取消
    cancelModify() {
      this.billOperationDetails = false
    },
    // 修改
    modify(row) {
      this.billOperationDetails = true
      this.judgeModify = 1
      this.carNumberModify = row['carNums'] //车牌号
      this.judgeCarNumMo = row['carNums'] //车牌号--修改--判断
      this.customerManagementList = row['phoneName'] //车主姓名
      // console.log(this.customerManagementList)
      this.carPhoneModify = row['phone'] //车主电话
      this.SETTB402ID = row['carNumID'] //车辆id
      this.tareIptModify = row['tareIpt'] //皮重
      this.carID = row['carID']
    },
    // 查询
    queryClick() {
      this.pageMo = 1
      this.pageList()
    },
    // 列表
    pageList() {
      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      if (this.userobj.pertb005.pertb005cb00 == 'CUS-1') {
        var ORMTB400ID = this.userobj.ormtb400.ORMTB400ID
      } else if (this.userobj.pertb005.pertb005cb00 == 'CUS-2') {
        var ORMTB400ID = this.userobj.ormtb410.ORMTB410ID
      }
      var postData = {
        SETTB402CA00: this.carNum, //车牌号
        sign: this.userobj.pertb005.pertb005cb00,
        personID: ORMTB400ID,
        page: this.pageMo,
        limit: this.limitMo,
      }

      this.tableData = []
      var moList
      var url = '/set/settb402/selectPageList'
      this.axios
        .post(url, postData)
        .then(res => {
          // console.log(res)
          setTimeout(() => {
            loading.close()
          }, 300)
          if (res.data.code == 200) {
            moList = res.data.data
            for (var i = 0; i < moList.length; i++) {
              this.tableData.push({
                carNums: moList[i]['SETTB402CA00'], //车牌号
                fname: moList[i]['fname'], //联系人
                fphone: moList[i]['fphone'], ////联系电话
                phoneName: moList[i]['names'], //联系人
                phone: moList[i]['phonenumber'], //联系电话
                tareIpt: moList[i]['SETTB402CA03'], //皮重
                carNumID: moList[i]['SETTB402ID'], //车辆基本信息ID
                carID: moList[i]['carID'], //车辆ID
              })
            }
            this.pagingPageMo = res.data.count
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },
    handleSizeChange(val) {
      this.pageMo = 1
      this.limitMo = val
      this.pageList()
    },
    // 点击页码
    handleCurrentChange(val) {
      this.pageMo = val
      this.pageList()
    },
    clearNoNum(value) {
      value = value.replace(/[^\d.]/g, '') //清除“数字”和“.”以外的字符
      value = value.replace(/\.{2,}/g, '.') //只保留第一个. 清除多余的
      value = value
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.')
      value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') //只能输入两个小数
      if (value.indexOf('.') < 0 && value != '') {
        //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        value = parseFloat(value)
      }
      return value
    },
  },
}
</script>

<style scoped>
.carManagement {
  background: #f3f3f3;
}

.bcarManagement-table {
  padding: 30px 20px 0;
}

.test111:active {
  background-color: red !important;
}

/* 新增--列表宽度 */
.billOperationRecord .systemCodePC-add-code-table-li-ipt {
  flex: 1.5;
}

.fontBlue {
  color: rgba(25, 159, 255, 1) !important;
}

.public_oparetionBlock_Menu .pulic_carNumber {
  margin-top: 6px;
  height: 40px;
  line-height: 40px;
  box-sizing: border-box;
  font-size: 14px;
  display: inline-block;
}

.billOperationRecord .public_oparetionBlock_Menu {
  height: 45px;
  align-items: center;
}

.billOperationRecord {
  background-color: #f3f3f3;
}

.billOperationRecord th,
.billOperationRecord td {
  text-align: center !important;
}

/* 弹框 */
.systemCodePC-add-code {
  padding: 0 20px;
}

.systemCodePC-pagesize {
  text-align: right;
  margin-top: 20px;
}
</style>
<style>
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
.itemMsg {
  padding: 0 10px;
}
.demo-table-expand .item-lxxx .el-form-item__content {
  width: 500px;
}
</style>
<style>
.sales-car-management-dialog {
	border: 1px solid rgba(207, 225, 245, 0.95);
	border-radius: 18px;
	background: #f8fbff;
	box-shadow: 0 24px 70px rgba(18, 52, 77, 0.22);
	overflow: hidden;
}

.sales-car-management-dialog .el-dialog__header {
	position: relative;
	height: auto;
	line-height: normal;
	padding: 18px 54px 16px 24px;
	vertical-align: middle;
	background: linear-gradient(135deg, #f5fbff 0%, #ffffff 48%, #eef8ff 100%);
	border-bottom: 1px solid rgba(219, 233, 247, 0.95);
	color: var(--fszs-text-strong);
}

.sales-car-management-dialog .el-dialog__header::before {
	content: "";
	position: absolute;
	left: 0;
	top: 0;
	width: 5px;
	height: 100%;
	background: linear-gradient(180deg, #199fff 0%, #5ac8fa 100%);
}

.sales-car-management-dialog .el-dialog__title {
	font-size: 18px;
	font-weight: 700;
	color: #17324d !important;
	letter-spacing: .2px;
}

.sales-car-management-dialog .el-dialog__headerbtn {
	top: 13px;
	right: 18px;
	border-radius: 50%;
	background: rgba(25, 159, 255, 0.08);
	transition: background .2s ease, transform .2s ease;
}

.sales-car-management-dialog .el-dialog__headerbtn:hover {
	background: rgba(25, 159, 255, 0.16);
	transform: rotate(90deg);
}

.sales-car-management-dialog .el-dialog__headerbtn .el-dialog__close {
	vertical-align: middle;
	font-size: 18px;
	color: #55708b !important;
}

.sales-car-management-dialog .el-dialog__body {
	padding: 22px 24px 24px;
	background: linear-gradient(180deg, #ffffff 0%, #f7fbff 100%);
	color: #31445a;
}

.sales-car-management-dialog .systemCodePC-add-code {
	padding: 0;
}

.sales-car-management-dialog .systemCodePC-add-code-table {
	display: flex;
	flex-direction: column;
	gap: 12px;
}

.sales-car-management-dialog .systemCodePC-add-code-table-li {
	display: grid;
	grid-template-columns: 118px minmax(0, 1fr) 64px;
	align-items: center;
	gap: 10px;
	min-height: 46px;
	padding: 10px 12px;
	border: 1px solid rgba(220, 232, 245, 0.9);
	border-radius: 12px;
	background: rgba(255, 255, 255, 0.86);
	box-shadow: 0 6px 16px rgba(23, 77, 124, 0.05);
	box-sizing: border-box;
}

.sales-car-management-dialog .systemCodePC-add-code-table-li-name {
	color: #203a56;
	font-size: 14px;
	font-weight: 600;
	text-align: right;
}

.sales-car-management-dialog .systemCodePC-add-code-table-li-ipt input,
.sales-car-management-dialog .systemCodePC-add-code-table-li-ipt .el-input__inner {
	width: 100%;
	height: 36px;
	line-height: 36px;
	padding: 0 12px;
	border: 1px solid #d7e5f3;
	border-radius: 9px;
	background: #fff;
	color: #1f3449;
	box-sizing: border-box;
	transition: border-color .18s ease, box-shadow .18s ease;
}

.sales-car-management-dialog .systemCodePC-add-code-table-li-ipt input:focus,
.sales-car-management-dialog .systemCodePC-add-code-table-li-ipt .el-input__inner:focus {
	border-color: #199fff;
	box-shadow: 0 0 0 3px rgba(25, 159, 255, 0.12);
	outline: none;
}

.sales-car-management-dialog .systemCodePC-add-code-table-li-text {
	color: #ff6b6b;
	font-size: 12px;
	white-space: nowrap;
}

.sales-car-management-dialog .systemCodePC-add-code-btn {
	display: flex;
	justify-content: center;
	gap: 16px;
	margin-top: 22px;
	padding-top: 18px;
	border-top: 1px solid rgba(223, 235, 247, 0.9);
}

.sales-car-management-dialog .systemCodePC-add-code-btn .el-button {
	min-width: 96px;
	border-radius: 9px;
}
</style>
